// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"UZ-z","categoryName":"VZ-z","categoryImage":"WZ-z","categoryContent":"XZ-z","bottomAligned":"YZ-z"};